require('../css/article.css');
require('infinite-scroll/dist/infinite-scroll.pkgd.min');
require('imagesloaded/imagesloaded.pkgd.min')
require('isotope-layout/dist/isotope.pkgd.min')

$(document).ready(function() {

});

window.bindMovies = function() {
    var genre = getGenre();
    var language = getLanguage();
    var sort = getSort();

    $grid = $('.grid');
    $grid.imagesLoaded( function() {
        $grid.isotope({
            itemSelector: '.item',
            getSortData: {
                latest: '[data-release]',
                popular: '[data-popularity]'
            }
        });

        doFilter();
    });

    doChooseGenre(genre);
    doChooseLanguage(language);
    doChooseSort(sort);

    $('.btn-choose-genre').click(function () {
        var btn = $(this);
        var genre = btn.data('genre');
        doChooseGenre(genre);
        doFilter();

        return false;
    });

    $('.btn-choose-language').click(function () {
        var btn = $(this);
        var language = btn.data('language');
        doChooseLanguage(language);
        doFilter();

        return false;
    });

    $('.btn-choose-sort').click(function () {
        var btn = $(this);
        var sort = btn.data('sort');
        doChooseSort(sort);
        if (sort == 'alphabet')
            $grid.isotope({ sortBy: sort, sortAscending: true  })
        else
            $grid.isotope({ sortBy: sort, sortAscending: false })

        return false;
    });
}

window.bindShowtimes = function() {
    $('.btn-select-region').change(function() {
        var region = $(this).val();
        setRegion(region);

        params.region = region;
        doGetShowtimes();
    });

    $('.btn-select-version').change(function() {
        var version = $(this).val();

        params.version = version;
        doGetShowtimes();
    })

    $('#dates .date').click(function() {
        var btn = $(this);
        params.date = btn.data('date');

        if (btn.hasClass('active') == false) {
            $('#dates .date').removeClass('active');
            btn.addClass('active');

            doGetShowtimes();
        }
        return false;
    });

    $('#showtimes').on('shown.bs.collapse', '.cinema.collapse', function() {
        const parent = $(this).parents('.btn-select-cinema');
        const cinemaId = parent.data('cinema-id');

        if (!$('.showtimes', parent).hasClass('loaded')) {
            $.get(generateRouteUrl('orn_web_showtime_movie', { id : params.id, date : params.date, cinema : cinemaId, version : params.version, ticketing : params.ticketing }), function(html) {
                $('.showtimes', parent).html(html).addClass('loaded');
                doGetShowtimePrice(html);
                appendUtmToAffiliateLinks()
            })
        }
    });

    $('#showtimes').on('click', '.btn-choose-region', function() {
        var region = $(this).data('region-id');
        $('.btn-select-region').val(region).trigger('change');

        return false;
    });

    doGetShowtimes();
}

window.bindInfiniteScroll = function(isAutoLoad) {
    var options = {
        path: params.url + '?page={{#}}',
        append: '.article',
        history: false,
        status: '.page-load-status'
    };
    if (isAutoLoad == false) {
        options.button = '.btn-view-more';
        options.scrollThreshold = false;
    }

    var $container = $('.card-infinite').infiniteScroll(options);
    $container.on('history.infiniteScroll', function () {
        dataLayer.push({
            'event': 'virtualPageView',
            'virtualUrl': location.pathname
        });
    });
    $container.on('load.infiniteScroll', function (event,response, path) {
        var text = $(response).text();
        if (!$.trim(text)) {
            $container.infiniteScroll('destroy');
            $('.page-load-status .infinite-scroll-request').hide();
            $('.page-load-status .infinite-scroll-last').show();
        }
    });
}

window.bindComments = function() {
    var limit = 5;
    var page = 1;

    if (params.totalComments > limit) {
        $('.comments').append('<a href="#" class="btn btn-light btn-block btn-fake-load-more mb-3">Xem thêm</a>')
        $('.block-comment:gt(4)').addClass('d-none');
    }

    $('.comments').on('click', '.btn-fake-load-more', function() {
        var btn = $(this);
        page = page + 1;
        var index = (limit * page) - 1;

        $('.block-comment:lt(' + index + ')').removeClass('d-none');

        if ($('.block-comment.d-none').length == 0)
            btn.remove();

        return false;
    });
}

window.bindRatingSummary = function(tab) {
    $('.summary-rating-percentage').text(params[tab]['percentage']);
    $('.summary-rating-point').text(params[tab]['point']);
    $('.summary-rating-total').text(params[tab]['total']);

    $('.summary-rating-progress .progress-bar').width(params[tab]['percentage'] + '%');
    if (params[tab]['percentage'] >= 80) {
        $('.summary-rating-percentage').parents('p').addClass('text-success');
        $('.summary-rating-progress .progress-bar').addClass('bg-success');
    }
    else if (params[tab]['percentage'] < 50) {
        $('.summary-rating-percentage').parents('p').addClass('text-danger');
        $('.summary-rating-progress .progress-bar').addClass('bg-danger');
    }
    else {
        $('.summary-rating-percentage').parents('p').addClass('text-secondary');
        $('.summary-rating-progress .progress-bar').addClass('bg-secondary');
    }

    var description = 'Đa số người xem đánh giá';
    if (params[tab]['max']['type'] == 'bad') {
        description += ' tiêu cực về bộ phim. ';
        if (params[tab]['range']['good']['percentage'] > 0)
            description +=  'Chỉ ' + params[tab]['range']['good']['percentage'] + '% nhận xét phim hay.';
    }
    if (params[tab]['max']['type'] == 'avg') {
        description += ' phim ở mức trung bình. ';
        if (params[tab]['range']['good']['percentage'] > 0)
            description += params[tab]['range']['good']['percentage'] + '% nhận xét phim hay.';
    }
    if (params[tab]['max']['type'] == 'good') {
        description += ' tích cực về bộ phim. ';
        if (params[tab]['range']['bad']['percentage'] > 0)
            description += 'Chỉ ' + params[tab]['range']['bad']['percentage'] + '% nhận xét phim không hay.';
    }

    $('.summary-rating-description').text(description);
}

function doGetShowtimes() {
    if (params.id && params.date) {
        $('#showtimes').html('<div class="text-center mb-3"> <div class="text-muted spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>');
        $.getJSON({
            url : generateRouteUrl('orn_web_showtime_movie', { id : params.id, date : params.date, region : params.region, version : params.version, ticketing : params.ticketing }),
            success : function(data) {
                if (data.cineplexes.length > 0) {
                    var html = '<div class="card"><div class="list-group list-group-flush">';
                    $.each(data.cineplexes, function(k, v) {
                        var cinemas = '';
                        $.each(v.cinemas, function(i, c) {
                            cinemas += doRenderCinema(c);
                        });

                        html += '<a href="#" class="list-group-item bg-light btn-select-cineplex' + (v.sponsored == 1 ? (' sponsored-cineplex-tracking sponsored-cineplex sponsored-cineplex-' + v.data.id) : '') + '" data-cineplex="' + v.data.slug + '" data-toggle="collapse" data-target="#showtime-cineplex-' + v.data.id + '"><div class="row align-items-center"><div class="col-auto"><div class="avatar avatar-sm"><img src="' + v.data.image + '" alt="' + v.data.name + '" class="avatar-img rounded"></div> </div><div class="col ml-n2"><h4 class="text-body mb-1 name">' + v.data.name + '</h4><p class="small text-muted mb-0">' + v.cinemas.length + ' rạp</p></div><div class="col-auto"><span class="text-muted h3"><i class="fe fe-chevron-right"></i></span></div></div></a><div class="list-group collapse' + (v.sponsored == 1 ? ' show' : '') + '" id="showtime-cineplex-' + v.data.id + '">' + cinemas + '</div>';
                    });
                    html += '</div></div>';
                }
                else {
                    if (data.regions.length > 0) {
                        var regions = '';
                        $.each(data.regions, function(i, r) {
                            regions += '<a href="#" class="font-weight-bold text-dark btn-choose-region" data-region-id="' + r.id + '">' + r.name + '</a>';
                            if (i < data.regions.length - 1)
                                regions += ', ';
                        });

                        html = '<div class="alert alert-light">' + Translator.trans('label.showtimes_available_in')  + ' ' + regions + '</div>';
                    }
                    else {
                        html = '<div class="alert alert-light">' + Translator.trans('label.showtimes_unavailable') + '</div>';
                    }
                }

                $('#showtimes').html(html);
                $('.sponsored-cinema').trigger('click');
            }
        });
    }
    else {
        $('#showtimes').html('<div class="alert alert-light">' + Translator.trans('label.showtimes_unavailable') + '</div>');
    }
}

function doRenderCinema(c) {
    var html = '';
    var mapHtml = ' - <a href="https://maps.google.com/?q=' + c.name + '" target="_blank">' + Translator.trans('label.map') + '</a>';
    var infoHtml = ' - <a href="' + generateRouteUrl('cinema_view', { slug : c.slug }) + '">' + Translator.trans('label.cinema_info') + '</a>';

    html += '<div class="list-group-item btn-select-cinema' + (c.sponsored == 1 ? (' sponsored-cinema-tracking sponsored-cinema sponsored-cinema-' + c.id) : '') + ' ' + (c.ticketing == 1 ? (' ticketing-cinema-tracking ticketing-cinema ticketing-cinema-' + c.id) : '') + '" data-cineplex="' + c.cineplex + '" data-cinema="' + c.slug + '" data-cinema-id="' + c.id + '" data-toggle="collapse" data-target="#showtime-cinema-' + c.id + '"><h4 class="text-body mb-0 name font-weight-normal">' + c.name + '</h4><div class="cinema collapse mt-0" id="showtime-cinema-' + c.id + '"><p class="small text-muted mb-3">' + c.location.address + infoHtml + mapHtml + '</p><div class="showtimes"><div class="text-center text-muted"><div class="spinner-border spinner-border-sm" role="status"></div></div></div></div></div>';

    return html;
}

function doFilter() {
    var genre = getGenre();
    var language = getLanguage();

    var filterLanguage = language == 'all' ? '*' : '.language-' + language;
    var filterGenre = genre == 'all' ? '*' : '.genre-' + genre;
    var filterStr = filterLanguage + filterGenre;
    if (filterLanguage == '*' && filterGenre == '*')
        filterStr = '*'

    $grid.isotope({ filter: filterStr });
}

function doChooseGenre(genre) {
    $('.btn-choose-genre').removeClass('active');
    $('.btn-choose-genre[data-genre="' + genre + '"]').addClass('active');
    setGenre(genre);

    var name = $('.btn-choose-genre[data-genre="' + genre + '"]').text();
    $('.genre-dropdown > a').text(genre == 'all' ? Translator.trans('label.genres') : name);
    $('.genre-dropdown').dropdown('hide');
}

function doChooseLanguage(language) {
    $('.btn-choose-language').removeClass('active');
    $('.btn-choose-language[data-language="' + language + '"]').addClass('active');
    setLanguage(language);

    var name = $('.btn-choose-language[data-language="' + language + '"]').text();
    $('.language-dropdown > a').text(language == 'all' ? Translator.trans('label.languages') : name);
    $('.language-dropdown').dropdown('hide');
}

function doChooseSort(sort) {
    $('.btn-choose-sort').removeClass('active');
    $('.btn-choose-sort[data-sort="' + sort + '"]').addClass('active');
    setSort(sort);

    var name = $('.btn-choose-sort[data-sort="' + sort + '"]').text();
    $('.sort-dropdown > a').text(sort == 'all' ? Translator.trans('label.order') : name);
    $('.sort-dropdown').dropdown('hide');
}

